import { c } from '../../../utils/tailwind-merge';
import { ChipProps } from './Chip.types';

export const Chip = ({ label, onClick, className }: ChipProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={c(
        'sm:mb-0 sm-mr-0 rounded-full border border-grey-400 px-4 py-1 text-base leading-6 tracking-tighter text-grey-900',
        className || ''
      )}
    >
      {label}
    </button>
  );
};
